@if (mustRefresh) {
  <iu-banner type="message">{{ 'editView.mustRefreshMsg' | translate }}</iu-banner>
}

@if (hasConflicts && remoteData && localData) {
  <iu-banner type="error">
    {{ 'editView.hasConflictsMsg' | translate }}
    <a style="text-decoration: underline; cursor: pointer" (click)="wantToMergeConflicts = true">{{
      'editView.verify' | translate
    }}</a>
    {{ 'editView.andSave' | translate }}
  </iu-banner>
}

<div id="{{ scrollPanelId }}" class="p-col dynamicContainer blade-grid">
  <ng-template iuDynamicContainer />
</div>
